// var AWS=any;
const axios = require('axios');

export default {
  install(Vue) {
    let app = new Vue({
      data() {
        return {
          apiUrl: process.env.VUE_APP_API_URL // PROD
        };
      },
      created: function () {
        let token = window.localStorage.getItem("token") || "";
        this.setAuthToken(token);
      },
      methods: {
        async getCall(url) {
          try {
            const apidata = await axios.get(`${this.apiUrl + url}`);
            return { isError: false, apidata: apidata.data }
          } catch (error) {
            return { isError: true, error }
          }
        },
        async postCall(url, data) {
          try {
            const apidata = await axios.post(`${this.apiUrl + url}`, data);
            return { isError: false, apidata: apidata.data }
          } catch (error) {
            return { isError: true, error }
          }
        },
        async putCall(url, data) {
          try {
            const apidata = await axios.put(`${this.apiUrl + url}`, data);
            return { isError: false, apidata: apidata.data }
          } catch (error) {
            return { isError: true, error }
          }
        },
        async patchCall(url, data) {
          try {
            const apidata = await axios.patch(`${this.apiUrl + url}`, data || {});
            return { isError: false, apidata: apidata.data }
          } catch (error) {
            return { isError: true, error }
          }
        },
        async deleteCall(url, data) {
          try {
            const config = data ? { data } : {};
            const apidata = await axios.delete(`${this.apiUrl + url}`, config);
            return { isError: false, apidata: apidata.data }
          } catch (error) {
            return { isError: true, error }
          }
        },
        async uploadImage(currentFile) {
          return new Promise((resolve, reject) => {


            //var self = this;
            let fileName = currentFile.name || (new Date().getTime().toString() + ".png");
            // let filetype = fileName.split(".")[1];
            let fileNameToSend = new Date().getTime() + fileName.substring(fileName.indexOf("."), fileName.length);
            let photoKey = "images/" + fileNameToSend;

            // const albumBucketName = "dolphino";
            const albumBucketName = "showup-bucket";
            const bucketRegion = "us-west-2";
            // const IdentityPoolId = "us-west-2:ff182092-2a76-489c-9d58-45ba742d9e7d";
            const IdentityPoolId = "us-west-2:28bedfdf-579c-4f92-875c-89788c168b20";
            AWS.config.update({
              region: "us-west-2", //'us-west-2',
              credentials: new AWS.CognitoIdentityCredentials({
                IdentityPoolId: IdentityPoolId,
              }),
            });

            var awsS3SObj = new AWS.S3({
              apiVersion: "2012-10-17", //'2006-03-01',
              params: {
                Bucket: albumBucketName,
              },
            });
            awsS3SObj.upload(
              {
                Key: photoKey,
                Body: currentFile,
                ACL: "public-read",
              }, function (err, data) {
                if (err) {
                  console.log("aws error --",err)
                  alert("There was an error uploading your Image: ");
                  resolve(null);
                } else {
                  resolve(data.Location); // "https://i.picsum.photos/id/469/200/300.jpg?hmac=XkjIV9jof2hkk4eUpQpbQVMBiSTfqdlJxIdlcIdEM6Q")
                }
              });
          })
        },
        async notify(message) {
          this.$notify({
            message: message,
            //  'Welcome to <b>Vue Black Dashboard Pro</b> - a beautiful resource for every web developer',
            timeout: 3000,
            icon: 'tim-icons icon-bell-55',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'info'
          });
        },
        setAuthToken(token) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        }
      }
    });

    Vue.prototype.$apiService = app;
  }
};
